module.exports = __webpack_public_path__ + "static/1.2.C.5 Plan subsol-e188871aae549c6c01f3cefbf0429e81.jpg";